/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkbookItemDto } from './WorkbookItemDto';
import {
    WorkbookItemDtoFromJSON,
    WorkbookItemDtoFromJSONTyped,
    WorkbookItemDtoToJSON,
    WorkbookItemDtoToJSONTyped,
} from './WorkbookItemDto';

/**
 * 
 * @export
 * @interface WorkbookDto
 */
export interface WorkbookDto {
    /**
     * 
     * @type {string}
     * @memberof WorkbookDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookDto
     */
    slug?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbookDto
     */
    isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbookDto
     */
    requireLogin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkbookDto
     */
    passwordHint?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkbookDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkbookDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Array<WorkbookItemDto>}
     * @memberof WorkbookDto
     */
    items?: Array<WorkbookItemDto> | null;
}

/**
 * Check if a given object implements the WorkbookDto interface.
 */
export function instanceOfWorkbookDto(value: object): value is WorkbookDto {
    return true;
}

export function WorkbookDtoFromJSON(json: any): WorkbookDto {
    return WorkbookDtoFromJSONTyped(json, false);
}

export function WorkbookDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkbookDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'isPublic': json['isPublic'] == null ? undefined : json['isPublic'],
        'requireLogin': json['requireLogin'] == null ? undefined : json['requireLogin'],
        'passwordHint': json['passwordHint'] == null ? undefined : json['passwordHint'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(WorkbookItemDtoFromJSON)),
    };
}

export function WorkbookDtoToJSON(json: any): WorkbookDto {
    return WorkbookDtoToJSONTyped(json, false);
}

export function WorkbookDtoToJSONTyped(value?: WorkbookDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'slug': value['slug'],
        'isPublic': value['isPublic'],
        'requireLogin': value['requireLogin'],
        'passwordHint': value['passwordHint'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(WorkbookItemDtoToJSON)),
    };
}

